import { render, staticRenderFns } from "./uvFile.vue?vue&type=template&id=e1216ace&scoped=true"
import script from "./uvFile.vue?vue&type=script&lang=js"
export * from "./uvFile.vue?vue&type=script&lang=js"
import style0 from "./uvFile.vue?vue&type=style&index=0&id=e1216ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1216ace",
  null
  
)

export default component.exports